import React from "react";
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  FormHelperText,
  Select,
} from "@chakra-ui/react";
const DropDown = ({ options, formik, id }) => {
  const styleClasses =
    options.styleClasses && options.styleClasses.length
      ? options.styleClasses.join(" ")
      : "";
  const dropDownErrors =
    Object.keys(formik.errors).length &&
    formik.errors.dropDown &&
    formik.errors.dropDown.length &&
    formik.errors.dropDown[id];
  const dropDownTouched =
    Object.keys(formik.touched).length &&
    formik.touched.dropDown &&
    formik.touched.dropDown.length &&
    formik.touched.dropDown[id];
  const hasError = dropDownTouched && dropDownErrors;
  const onChangedropDown = (e, id) => {
    const setValues = formik.setValues;
    const formikValues = formik.values;
    const dropDown = [...formik.values.dropDown];
    const currentValues = e.target.value;
    let newUpdateValue = true;
    Object.keys(formikValues.dropDown).some((field, i) => {
      Object.keys(formikValues.dropDown[i]) == e.target.name &&
        (formikValues.dropDown[i][e.target.name] = e.target.value);
      if (
        formikValues.dropDown.length - 1 == i &&
        Object.keys(formikValues.dropDown[i]) == e.target.name
      ) {
        newUpdateValue = false;
      }
      if (!newUpdateValue) {
        return;
      }
    });
    if (newUpdateValue) {
      const currentValuesWithId = {
        [e.target.name]: currentValues,
      };
      dropDown.push(currentValuesWithId);
    }
    setValues({ ...formikValues, dropDown });
  };
  return (
    <FormControl
      className={styleClasses}
      isInvalid={hasError ? true : false}
      mb="2"
      isRequired={options.isRequired}
    >
      {options.showLabel && (
        <FormLabel htmlFor="dropDown" fontSize="14px">
          {options.label}
        </FormLabel>
      )}
      <Select
        className="dropDownField"
        width="60%"
        name={`dropDown.${id}.${options.label}`}
        type="text"
        onChange={(e) => {
          onChangedropDown(e, id);
        }}
        value={
          formik.values &&
          formik.values["dropDown"][`dropDown.${id}.${options.label}`]
        }
      >
        {" "}
        <option key={"00"} value={""}></option>
        {options.choices.map((element, index) => {
          return (
            <option key={index} value={element.value}>
              {element.value}
            </option>
          );
        })}
      </Select>

      <FormHelperText>{options.helpText}</FormHelperText>
      {hasError ? (
        <FormErrorMessage>{formik.errors.dropDown}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};

export default DropDown;
